import React from 'react';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames'

const styles = {
    card: {
        float: 'left',
        margin: '-20px 20px 0 15px',
        zIndex: 100,
        borderRadius: 3,
        width: 'auto'
    },
    icon: {
        display: 'inline-block',
        width: 54,
        height: 54,
        fontSize: 50,
        color: '#fff',
        textAlign: 'center',
        padding: 14,
    },
};

const CardIcon = ({ iconName, classes, bgColor }) => (
    <Card className={classes.card} style={{ backgroundColor: bgColor }}>
        <i className={classnames(classes.icon, `icon-${iconName}`)} />
    </Card>
);

export default withStyles(styles)(CardIcon);